var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.75 2.25a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-.5v3a2.25 2.25 0 0 0 4.5 0v-3h-.5a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1h-.5v3a3.25 3.25 0 1 1-6.5 0v-3h-.5a.5.5 0 0 1-.5-.5m1 7a.5.5 0 0 0 0 1h6.5a.5.5 0 0 0 0-1z",
    clipRule: "evenodd"
  })));
});
const SvgTextEditUnderlinesmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTextEditUnderlinesmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xLjc1IDIuMjVDMS43NSAxLjk3Mzg2IDEuOTczODYgMS43NSAyLjI1IDEuNzVIMy4yNUg0LjI1QzQuNTI2MTQgMS43NSA0Ljc1IDEuOTczODYgNC43NSAyLjI1QzQuNzUgMi41MjYxNCA0LjUyNjE0IDIuNzUgNC4yNSAyLjc1SDMuNzVWNS43NUMzLjc1IDYuOTkyNjQgNC43NTczNiA4IDYgOEM3LjI0MjY0IDggOC4yNSA2Ljk5MjY0IDguMjUgNS43NVYyLjc1SDcuNzVDNy40NzM4NiAyLjc1IDcuMjUgMi41MjYxNCA3LjI1IDIuMjVDNy4yNSAxLjk3Mzg2IDcuNDczODYgMS43NSA3Ljc1IDEuNzVIOC43NUg5Ljc1QzEwLjAyNjEgMS43NSAxMC4yNSAxLjk3Mzg2IDEwLjI1IDIuMjVDMTAuMjUgMi41MjYxNCAxMC4wMjYxIDIuNzUgOS43NSAyLjc1SDkuMjVWNS43NUM5LjI1IDcuNTQ0OTMgNy43OTQ5MyA5IDYgOUM0LjIwNTA3IDkgMi43NSA3LjU0NDkzIDIuNzUgNS43NVYyLjc1SDIuMjVDMS45NzM4NiAyLjc1IDEuNzUgMi41MjYxNCAxLjc1IDIuMjVaTTIuNzUgOS4yNUMyLjQ3Mzg2IDkuMjUgMi4yNSA5LjQ3Mzg2IDIuMjUgOS43NUMyLjI1IDEwLjAyNjEgMi40NzM4NiAxMC4yNSAyLjc1IDEwLjI1SDkuMjVDOS41MjYxNCAxMC4yNSA5Ljc1IDEwLjAyNjEgOS43NSA5Ljc1QzkuNzUgOS40NzM4NiA5LjUyNjE0IDkuMjUgOS4yNSA5LjI1SDIuNzVaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";